<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="品牌名称">
      <el-input v-model="queryParam.name" placeholder="输入品牌名称" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="品牌状态">
        <el-option label="正常" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListBrand">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doBrandAdd()"
          v-hasPermission="['brand:add']"
          >添加品牌</el-button
        >
        <el-button
          type="danger"
          :loading="loadingexport" @click="doExportBrand"
          v-hasPermission="['brand:export']"
          >{{loadingexport ? "处理中 ..." : "导出品牌"}}</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table :data="tableData" v-loading="loadingData" class="mainTable" row-key="brandid">
        <el-table-column label="品牌ID" prop="brandid"/>
        <el-table-column label="品牌" prop="name"/>
        <!-- <el-table-column label="描述" prop="desc"/> -->
        <!-- <el-table-column label="日期" prop="created">
        <template #default="scope">
          <span
            v-text="util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')"
          ></span>
        </template>
      </el-table-column> -->
        <el-table-column label="状态" prop="status">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showCommonStatus(scope.row.status)"></span>
            </el-tag>
            <el-switch
              :model-value="scope.row.status"
              v-hasPermission="['brand:edit']"
              :active-value="1"
              :inactive-value="2"
              size="small"
              @change="doBrandStatus(scope.$index, scope.row, 'status')"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doBrandEdit(scope.$index, scope.row)"
              v-hasPermission="['brand:edit']"
              >编辑</el-link
            >

            <!-- <el-link
              type="primary"
              size="small"
              @click="open('brand:view', scope.row)"
              v-hasPermission="['brand:view']"
              >查看</el-link
            > -->
            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              width="200px"
              @confirm="doBrandDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"
      ><div>
        <!-- <el-button
            type="danger"
            >添加用户</el-button> -->
      </div></el-col
    >
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="45%"
    @close="doBrandClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="brandFormRef"
        :model="brandForm"
        :rules="rules"
        label-width="120px"
        autocomplete="off"
      >
        <el-form-item label="品牌名称" prop="name">
          <el-input
            v-model.trim="brandForm.name"
            placeholder="请输入品牌名称"
          />
        </el-form-item>
        <!-- <el-form-item label="描述" prop="desc">
          <el-input
            v-model.trim="brandForm.desc"
            placeholder="请输入品牌描述"
          />
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="brandForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doBrandClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doBrandSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
      
<script setup>
import { ref, onMounted } from "vue";
// import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listBrand, saveBrand, exportBrand,deleteBrand } from "@/api/brand";
import storage from  "@/util/storage";
import util from "@/util/tool.js";


// const router = useRouter();
// let open = (routeName, row) => {
//   storage.saveSessionObject("brandPath",queryParam.value)
//   router.push({
//     name: routeName,
//     params: { id: row.brandid },
//     // query: { name: row.name },
//   });
// };

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const brandFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("添加品牌");


//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  status: "",
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    status: "",
  };
  getListBrand();
};

const brandForm = ref({
  brandid: null,
  name: "",
  desc: "",
  status: 1,
});

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("brandPath")
  if (query) {
    queryParam.value = query
  }
  getListBrand();
});

const doBrandAdd = () => {
  title.value = "新增品牌";
  resetForm();
};

const doBrandEdit = (index, obj) => {
  title.value = "编辑品牌";
  // brandForm.value = obj;//直接赋值会出问题

  brandForm.value = {
    brandid: obj.brandid,
    name: obj.name,
    desc: obj.desc,
    status: obj.status,
  };
};

const doBrandClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  brandFormRef.value.resetFields()
};

const resetForm = () => {
  brandForm.value = {
    brandid: null,
    name: "",
    desc: "",
    status: 1,
  };
};

const doBrandSave = () => {
  brandFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveBrand(brandForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListBrand();
          doBrandClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新状态
const doBrandStatus = (index, obj) => {
  let status = obj.status == 1 ? 2 : 1;
  let data = { status, name: obj.name, brandid: obj.brandid.toString() };
  tableData.value[index].status = status;
  saveBrand(data);
};


const doBrandDelete = (index, obj) => {
  deleteBrand(obj).then((res) => {
    if (res.data.code === 1) {
      getListBrand();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListBrand();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListBrand();
};

//品牌表API
const getListBrand = () => {
  storage.remove('brandPath')
  listBrand(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false;
  });
};

const doExportBrand = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.pageSize = 5000

  loadingexport.value = true;
  exportBrand(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 1,
      max: 100,
      message: "名称长度1到100",
      trigger: "blur",
    },
  ],
  desc: [
    {
      message: "请填写品牌描述",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "描述长度2到100",
      trigger: "blur",
    },
  ],
});
</script>